export type DinhMucCoDinhFormMode = 'create' | 'edit';

export type DinhMucCoDinhWizardStep = 'meta' | 'dmVatTu';

/** Header fields for POST tao-moi / cap-nhat */
export interface DinhMucCoDinhFormFields {
  id_cap_sc: number;
  id_danh_muc_toa_xe: number;
  so_van_ban: string;
  ngay_ban_hanh: string;
  ngay_hieu_luc: string;
  ngay_het_han: string | null;
  mo_ta?: string;
}

export interface DinhMucCoDinhDmVatTuInput {
  id_vat_tu: number;
  so_luong: number;
}

/** Draft line before normalization (wizard step 2) */
export interface DinhMucCoDinhVatTuLineDraft {
  _key: string;
  id_vat_tu: number;
  ma_vat_tu?: string;
  ten_vat_tu?: string;
  don_vi_tinh?: string;
  so_luong: number;
}

export function normalizeDmVatTuLine(
  line: DinhMucCoDinhVatTuLineDraft
): DinhMucCoDinhDmVatTuInput | null {
  const id_vat_tu = Number(line.id_vat_tu);
  const so_luong = Number(line.so_luong);

  if (!id_vat_tu || !so_luong || so_luong <= 0 || Number.isNaN(so_luong)) {
    return null;
  }

  return {
    id_vat_tu,
    so_luong,
  };
}

/** POST /dinh-muc-co-dinh/tao-moi */
export interface DinhMucCoDinhCreateRequest {
  dinhMucCoDinh: DinhMucCoDinhFormFields;
  dmVatTu: DinhMucCoDinhDmVatTuInput[];
}

/** POST /dinh-muc-co-dinh/cap-nhat/{id} */
export interface DinhMucCoDinhUpdateRequest {
  dinhMucCoDinh: DinhMucCoDinhFormFields;
  dmVatTu: DinhMucCoDinhDmVatTuInput[];
}

/** Peer record that would be expired if this save proceeds */
export interface DinhMucCoDinhWillExpire {
  id: number;
  so_van_ban: string;
  ngay_ban_hanh: string;
  ngay_hieu_luc: string;
  ngay_het_han: string | null;
  id_cap_sc: number;
  id_danh_muc_toa_xe: number;
  ngay_het_han_moi: string;
}

/** Exact duplicate conflict record (shape may include extra fields) */
export interface DinhMucCoDinhDuplicate {
  id?: number;
  so_van_ban?: string;
  ngay_ban_hanh?: string;
  ngay_hieu_luc?: string;
  ngay_het_han?: string | null;
  id_cap_sc?: number;
  id_danh_muc_toa_xe?: number;
}

/** POST /dinh-muc-co-dinh/kiem-tra — dry-run validation before create/update */
export interface DinhMucCoDinhCheckRequest {
  id?: number;
  dinhMucCoDinh: DinhMucCoDinhFormFields;
  dmVatTu?: DinhMucCoDinhDmVatTuInput[];
}

export interface DinhMucCoDinhCheckResult {
  valid: boolean;
  can_save: boolean;
  errors: string[];
  duplicate: DinhMucCoDinhDuplicate | null;
  will_expire: DinhMucCoDinhWillExpire | null;
  message?: string;
}
